"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VideoFileSource = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _PropTypes = require("./PropTypes");
var _useVideoJSPlayer = require("../../hooks/useVideoJSPlayer/useVideoJSPlayer");
var _useVideoJSMetrics = require("../../hooks/useVideoJSMetrics/useVideoJSMetrics");
var VideoFileSource = exports.VideoFileSource = function VideoFileSource(_ref) {
  var source = _ref.source,
    mediaPlayer = _ref.mediaPlayer,
    serverTime = _ref.serverTime,
    serverTimeDelta = _ref.serverTimeDelta;
  var isObjectSourceValue = (0, _typeof2["default"])(source.value) === 'object';
  var settings = isObjectSourceValue ? source.value : mediaPlayer;
  var videoUrl = isObjectSourceValue ? source.value.url : source.value;
  var playerRef = (0, _useVideoJSPlayer.useVideoJSPlayer)(source._id, videoUrl, settings, serverTime, serverTimeDelta);
  (0, _useVideoJSMetrics.useVideoJSMetrics)(source, playerRef);
  return /*#__PURE__*/_react["default"].createElement("video", {
    id: "media_player_".concat(source._id),
    "data-testid": "video_".concat(source._id),
    className: "video-js vjs-default-skin",
    style: {
      backgroundColor: 'transparent'
    }
  }, "Your browser does not support the video file");
};
VideoFileSource.defaultProps = {
  //@deprecated in favor of source.value object format
  mediaPlayer: {}
};
VideoFileSource.propTypes = {
  source: _PropTypes.Source,
  onVolumeChanged: _propTypes["default"].func,
  onSeekTimeChanged: _propTypes["default"].func,
  //@deprecated in favor of source.value object format
  mediaPlayer: _PropTypes.MediaPlayer,
  serverTime: _propTypes["default"].number,
  serverTimeDelta: _propTypes["default"].number
};